import { THEME_OPTION } from 'enums';
import React from 'react';
import { useAppSelectorShallow } from 'store/hooks';
import { themeSelector } from 'store/reducer/setting/selectors';

interface Props {
  title: string;
  duration: string;
}

const YouTubeMetaData = ({ title, duration }: Props) => {
  const themeMode = useAppSelectorShallow(themeSelector);
  return (
    <div className='w-full flex items-center gap-2'>
      <div className='w-fit text-xs truncate' data-testid='youtube-video-title'>
        {title}
      </div>
      <div
        className={`w-fit text-xs ${themeMode === THEME_OPTION.DARK ? 'text-primary-900' : 'text-blue-700'}`}
        data-testid='youtube-video-duration'>{`(${duration})`}</div>
    </div>
  );
};

export default YouTubeMetaData;
